import { RequestManagerService } from './request-manager.service';
import { AdditionalRequestParamsInterface } from '../helpers/prepare-request-data.helper';
import { GM_METHODS } from '../constants/gm-methods';

export interface SuccessResponseBodyInterface {
    readonly status: number;
    readonly statusDescription: string;
    readonly statusUserMessage?: string;
}

export interface ConfirmationParamsInterface extends AdditionalRequestParamsInterface {
    verificationCode: string;
}

export interface ResetPasswordParamsInterface extends AdditionalRequestParamsInterface {
    password: string;
    verificationCode: string;
}

// Żeby nie robić dwóch zapytań (getConfiguration i np. confirmRegistration)
// W przypadku, gdy aplikacja do swojego działania potrzebuje tylko jednego (np. confirmRegistration)
const authRequestUrl = 'https://b2c-www.redefine.pl/rpc/auth/';

export class UserService {
    public static confirmRegistration(params: ConfirmationParamsInterface): Promise<SuccessResponseBodyInterface> {
        return RequestManagerService.makeRequest(authRequestUrl, GM_METHODS.CONFIRM_REGISTRATION, params);
    }

    public static confirmEmailChange(params: ConfirmationParamsInterface): Promise<SuccessResponseBodyInterface> {
        return RequestManagerService.makeRequest(authRequestUrl, GM_METHODS.CONFIRM_EMAIL_CHANGE, params);
    }

    public static resetPassword(params: ResetPasswordParamsInterface): Promise<SuccessResponseBodyInterface> {
        return RequestManagerService.makeRequest(authRequestUrl, GM_METHODS.RESET_PASSWORD, params);
    }
}
